export const LLMType = {
    CHATGPT: 1,
};